import { useRef } from "react";
import styled from "styled-components";

interface IIframePageProps {
  iframeRoute: string;
  hideLayoutBars?: boolean;
}

const IframePage: React.FC<IIframePageProps> = ({
  iframeRoute,
  hideLayoutBars = false,
}) => {
  const iFrameRef = useRef<HTMLIFrameElement>(null);
  const paramString = iframeRoute.split('?')[1];
  const queryString = new URLSearchParams(paramString);
  const urlParamsLength = queryString.size;
  console.log('urlParamsLength', urlParamsLength);
  return (
    <IframeWrapper
      $hideLayoutBars={hideLayoutBars}
      ref={iFrameRef}
      src={`${iframeRoute}${urlParamsLength ? '&' : '?'}${!iframeRoute.includes('iframe') ?
      `iframe=true` : ''
      }`}
      allow='clipboard-read; clipboard-write; microphone; camera; autoplay; encrypted-media; fullscreen; display-capture'
    />
  );
}

export default IframePage;

export const IframeWrapper = styled.iframe<{
  $hideLayoutBars?: boolean;
}>`
  border: none;
  height: 100vh;
`;

